<form (ngSubmit)="save()" [formGroup]="form">
	<h1 mat-dialog-title>Enter Password</h1>
	<mat-dialog-content>
		<div fxLayout="column">
			<mat-form-field fxFlex>
				<mat-label>{{'loginView.passwordLabel' | translate}}</mat-label>
				<input [type]="showPassword ? 'text' : 'password'" formControlName="password" matInput required/>
				<button (click)="toggleShowPassword()" [matTooltip]="showPassword ? 'Hide Password' : 'Show Password'"
						color="primary" mat-icon-button
						matSuffix matTooltipPosition="left" type="button">
					<mat-icon>{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
				</button>
				<mat-error>{{'loginView.passwordLabel' | translate}} is required</mat-error>
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
		<button [color]="'accent'" mat-dialog-close mat-raised-button type="button">
			Cancel
		</button>
		<button [color]="'primary'" mat-raised-button type="submit">
			Save
		</button>
	</mat-dialog-actions>
</form>
